"use strict";
/*
 * Created on 06 17 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var DashboardTask =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DashboardTask, _DomainObject_1$Domai);

  /**
   * @param id
   * @param message that will be displayed to a user. The first message variable is a category name.
   * @param roles users with any of these roles (and permission bellow) can see the task on their dashboard
   * @param permission users with this permission (and role above) can see the task on their dashboard
   * @param productCategoryId some tasks relate to one category
   * @param deadline the task is marked as finished automatically after this date
   * @param state the current state of the task (e.g. open, finished)
   * @param type defines what is the task about - what users has to do to finish it
   */
  function DashboardTask(id, message, roles, permission, productCategoryId, deadline, state, type) {
    var _this;

    _classCallCheck(this, DashboardTask);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DashboardTask).call(this));
    _this.id = id;
    _this.message = message;
    _this.roles = roles;
    _this.permission = permission;
    _this.productCategoryId = productCategoryId;
    _this.deadline = deadline;
    _this.state = state;
    _this.type = type;
    return _this;
  }

  return DashboardTask;
}(DomainObject_1.DomainObject);

exports.DashboardTask = DashboardTask;